// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

const baseRoute = '/safety-driver-annotations'

export const DashboardAreaPaths = {
  Assessment: 'assessment-cleanup',
  PceAnalysis: 'pce-analysis',
}

const BaseSafetyDriverAnnotationsAreaRoutes = {
  route: baseRoute,
  Annotation: { route: `/annotation` },
  Detail: { route: `/annotation/:id` },
  Dashboard: { route: `/dashboard` },
  Assessment: { route: `/dashboard/${DashboardAreaPaths.Assessment}` },
  PceAnalysis: { route: `/dashboard/${DashboardAreaPaths.PceAnalysis}` },
}

export const SafetyDriverAnnotationsAreaRoutes = transformRoutes(
  BaseSafetyDriverAnnotationsAreaRoutes,
)
